import { render, staticRenderFns } from "./MobileProjectsServiceReport.vue?vue&type=template&id=67f24a03&scoped=true"
import script from "./MobileProjectsServiceReport.vue?vue&type=script&lang=js"
export * from "./MobileProjectsServiceReport.vue?vue&type=script&lang=js"
import style0 from "./MobileProjectsServiceReport.vue?vue&type=style&index=0&id=67f24a03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f24a03",
  null
  
)

export default component.exports